import { CheckCircle2 } from "lucide-react";

const reasons = [
  { t: "Implementación real", d: "No vendo PDFs. Yo configuro, integro y opero el sistema contigo." },
  { t: "+20 automatizaciones implementadas", d: "Experiencia técnica probada en bots, flujos e integraciones complejas." },
  { t: "Stack completo", d: "Ads, IA, automatización y CRM funcionando como un solo motor." },
  { t: "Enfoque en ventas", d: "Cada decisión técnica está atada a un KPI comercial real." },
  { t: "Atención personalizada", d: "Trabajo con pocos clientes a la vez. Tu cuenta no es un ticket." },
  { t: "Resultados medibles", d: "Reportes con ROAS, CPL, conversación-a-venta y atribución por canal." },
];

export default function WhyDaos() {
  return (
    <section id="why" data-testid="why-section" className="relative py-24 sm:py-32">
      <div className="container-x">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5 reveal">
            <div className="eyebrow mb-5">Por qué Daos Ads</div>
            <h2 className="font-display font-extrabold text-white text-4xl sm:text-5xl tracking-tighter leading-[1.05]">
              No soy una agencia. Soy un <span className="text-gradient">operador</span>.
            </h2>
            <p className="mt-6 text-zinc-400 text-lg max-w-md">
              Las agencias delegan. Los freelancers improvisan. Yo opero, mido, optimizo y entrego un sistema que tu equipo puede usar sin depender de mí.
            </p>
          </div>
          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-3">
            {reasons.map((r, i) => (
              <div key={r.t} className="reveal grad-border p-6" style={{ transitionDelay: `${i * 50}ms` }}>
                <div className="flex items-start gap-3">
                  <CheckCircle2 className="w-5 h-5 text-[#ff8a00] mt-0.5 shrink-0" />
                  <div>
                    <div className="text-white font-display font-semibold">{r.t}</div>
                    <p className="mt-1 text-zinc-400 text-sm leading-relaxed">{r.d}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
